import { render, staticRenderFns } from "./IlmoitusFilesTable.vue?vue&type=template&id=2636cae1&scoped=true"
import script from "./IlmoitusFilesTable.vue?vue&type=script&lang=js"
export * from "./IlmoitusFilesTable.vue?vue&type=script&lang=js"
import style0 from "./IlmoitusFilesTable.vue?vue&type=style&index=0&id=2636cae1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2636cae1",
  null
  
)

export default component.exports